export enum EModules {
  TOPCON_TECH = "TOPCON_TECH",
  TOPCON_CUSTOMER = "TOPCON_CUSTOMER"
}
